class PageNoDisplay {
  constructor(options) {
    const _ = this;
    if (!options) return;

    _.options = $.extend({
      wrap: null
    }, options);

    _.wrap = null;

    _.currentNoWrap = null;
    _.totalNoWrap = null;
  }

  init() {
    const _ = this;

    _.setInstance();

    return _;
  }

  setInstance() {
    const _ = this;

    _.wrap = $(_.options.wrap);
    _.currentNoWrap = $('.current', _.wrap);
    _.totalNoWrap = $('.total', _.wrap);
  }

  setCurrentNo(index) {
    this.currentNoWrap.text(index);
    return this;
  }

  setTotalNo(index) {
    this.totalNoWrap.text(index);
    return this;
  }
}

export default PageNoDisplay;


// WEBPACK FOOTER //
// ./_src/js/main/promotionBanner/PageNoDisplay.js